import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const ArrowIcon = ({ size = 18, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12h16M14 6l6 6-6 6" />
  </svg>
)
